// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClockCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/ClockCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleTwoToneSvg
  }));
};

ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
export default React.forwardRef(ClockCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ClockCircleTwoTone.js
// module id = 781
// module chunks = 0